import moment from 'moment-timezone';

export const dateFormat = (timestamp) => {
    return moment.tz(timestamp, 'Asia/Jerusalem').format('DD/MM/YYYY, h:mm:ss A');
};

export const timeFormat = (timestamp) => {
    return moment.tz(timestamp, 'Asia/Jerusalem').format('hh:mm A');
};

export const dateOnlyFormat = (timestamp) => {
    return moment.tz(timestamp, 'Asia/Jerusalem').format('DD MMM YYYY');
};